import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  &:last-child {\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link, Box } from "@miro-site/core";
import styled from "styled-components";
import theme from "./theme";
var FooterLinksContainer = styled(Box).attrs({
    $styles: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: [
            "center",
            "center",
            undefined
        ],
        flex: [
            "0 0 100%",
            "0 0 100%",
            null
        ]
    },
    $mt: [
        20,
        20,
        null
    ]
}).withConfig({
    componentId: "sc-db8a7f34-0"
})(_templateObject());
var Copyright = styled(Box).attrs({
    $styles: {
        fontSize: theme.footer.links.bottom.fontSize,
        lineHeight: theme.footer.links.bottom.lineHeight,
        color: theme.colors.primaryWhite
    },
    $mr: theme.footer.copyright.margin.right
}).withConfig({
    componentId: "sc-db8a7f34-1"
})(_templateObject1());
var CopyrightLink = styled(Link).withConfig({
    componentId: "sc-db8a7f34-2"
})(_templateObject2(), function(props) {
    return props.theme.normalizeStyles(theme.footer.links.bottom);
});
var FooterLink = styled(Link).attrs({
    $mr: theme.footer.copyrightLink.margin.right
}).withConfig({
    componentId: "sc-db8a7f34-3"
})(_templateObject3(), function(props) {
    return props.theme.normalizeStyles(theme.footer.links.bottom);
});
var FooterLinks = function(props) {
    var links = props.links;
    var year = new Date().getFullYear();
    return /*#__PURE__*/ _jsxs(FooterLinksContainer, {
        children: [
            /*#__PURE__*/ _jsxs(Copyright, {
                children: [
                    "\xa9 ",
                    year,
                    " ",
                    /*#__PURE__*/ _jsx(CopyrightLink, {
                        href: "https://miro.com/",
                        $color: "white",
                        $size: "medium",
                        children: "Miro"
                    })
                ]
            }),
            links.map(function(link, index) {
                return /*#__PURE__*/ _jsx(FooterLink, {
                    href: link.path,
                    $color: "white",
                    children: link.title
                }, index);
            })
        ]
    });
};
export default FooterLinks;
